import { Btn, A } from './components';
import { ILinkBtn } from './components/Btn/linkBtn.models';
import { ILinkA } from './components/A/linkA.models';
import { StrictUnion, areAnchorPropsOf } from '../../cta.models';

type ILinkProps = StrictUnion<ILinkBtn | ILinkA>;

export const Link: React.FC<ILinkProps> = (props) => {
  if (areAnchorPropsOf<ILinkA>(props) && !props.withoutHref) {
    return <A {...props} />;
  }

  const { href, ...buttonProps } = props as any;

  return <Btn {...buttonProps} />;
};
